import { useState } from 'react'

import { BlockForm } from './blockForm'
import { PrefectureList } from './prefectureList'

import { PrefectureResult } from 'interface/prefecture'

import {
  Paper, Stack
} from "@mui/material"

type AreaBarProps = {
  defaultBlockCode: string
  onSelectedBlock: (blockCode: string) => void
  defaultPrefectureCodes: string[]
  onSelectedPrefecture: (prefectures: PrefectureResult[]) => void
}
export const AreaBar = ({
  defaultBlockCode,
  onSelectedBlock,
  defaultPrefectureCodes,
  onSelectedPrefecture
}: AreaBarProps) => {
  const [selectedBlockCode, setSelectedBlockCode] = useState<string>(defaultBlockCode)
  return (
    <Paper square sx={{
      width: '10em',
      minWidth: '10em',
      position: 'relative',
      height: '100%',
      maxHeight: '100%',
      overflow: 'hidden',
      zIndex: 2,
      boxShadow: '1px 0 2px rgb(0,0,0,0.3)',
    }}>
      <Stack sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        maxHeight: '100%',
        boxSizing: 'border-box'
      }} spacing={1} paddingTop={1}>
        <BlockForm
          defaultBlockCode={selectedBlockCode}
          onSelectedBlock={(code) => {
            setSelectedBlockCode(code)
            onSelectedBlock(code)
          }}
        />
        <PrefectureList
          selectedBlockCode={selectedBlockCode}
          defaultPrefectureCodes={defaultPrefectureCodes}
          onSelectedPrefectures={onSelectedPrefecture}
          sx={{
            flexGrow: 1,
            overflow: 'auto'
          }}
        />
      </Stack>
    </Paper>
  )
}